import { render, staticRenderFns } from "./SendValueCommerceData.vue?vue&type=template&id=32c6a128&scoped=true"
import script from "./SendValueCommerceData.vue?vue&type=script&lang=js"
export * from "./SendValueCommerceData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c6a128",
  null
  
)

export default component.exports